// Register the AL-AXE service worker so browsers offer the native install
// prompt and the app works offline. Only registers in production builds to
// keep the CRA dev server (HMR/websockets) unaffected.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => {
        // Non-fatal; app still works without the SW.
        console.warn("[AL-AXE] Service worker registration failed:", err);
      });
  });
}
